export default __webpack_public_path__ + "static/es-mx-838d2617787e8a5896ef11191c01cec8.svg";